import { MIN_POLYGON_POINTS } from "./constants";
import type { RemovePoint } from "./types";

export const removePoint: RemovePoint = ({ points, index }) => {
  if (points.length <= MIN_POLYGON_POINTS) return null;

  return points.filter((_point, pointIndex) => pointIndex !== index);
};
